<template>
  <v-container fluid>
    <div class="invoice-view">
      <v-card flat>
        <ReportViewBar
        title="Sales Summary"
        :start="dateTime.start"
        :end="dateTime.end"
        :showDate="true"
      />
      <v-card-text>
        <v-layout row wrap class="no-print">
          <v-flex xs12 md4>
            <v-select
              v-model="selectedLocations"
              :items="locations"
              item-text="name"
              item-value="id"
              label="Select Location"
              placeholder="All Locations"
              multiple
              solo
              chips
              @input="locationsSelected"
              clearable
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ selectedLocations.length - 1 }} others)
                </span>
              </template>
            </v-select>

            <v-select
              v-model="selectedEmployees"
              :items="employees"
              item-text="name"
              item-value="id"
              label="Select Employees"
              placeholder="All Employees"
              multiple
              chips
              solo
              @input="loadSales"
              clearable
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >
                  (+{{ selectedEmployees.length - 1 }} others)
                </span>
              </template>
            </v-select>
          </v-flex>

          <v-spacer></v-spacer>
          <v-flex xs12 md3>
            <DateTimePicker
              :range="true"
              v-model="dateTime"
              :initStartDate="start"
              :initEndDate="end"
              @submit="loadSales()"
            />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
      <v-container py-0 fluid v-else>

        <v-layout column>
          <!-- Revenue Charts -->
          <v-flex class="my-2">
            <h2>Organization Sales Summary </h2>
          </v-flex>

          <v-layout row wrap v-if="revenueChartData">
            <v-flex xs12 sm6 pa-1>
              <PieChart :chartData="revenueChartData">
                <template slot="header">
                  <v-layout column class="text-xs-center">
                    <h3>Revenue Breakdown</h3>
                    <h4>{{ salesData.revenue | currency }} </h4>
                  </v-layout>
                </template>
              </PieChart>
            </v-flex>
            <v-flex xs12 sm6 pa-1>
              <PieChart :chartData="salesChartData">
                <template slot="header">
                  <v-layout column class="text-xs-center">
                    <h3>Profit and Loss</h3>
                    <h4>Total Sale: {{ salesData.netSales | currency }} </h4>
                  </v-layout>
                </template>
              </PieChart>
            </v-flex>
          </v-layout>

          <!-- Revenue for entire Organization -->
          <v-layout mt-2 column v-if="salesData">
            <v-layout row wrap>

              <v-flex xs12 sm6 class="pa-1">
                <v-card hover @click="openRevenue">
                  <v-card-text> Revenue {{ salesData.revenue | currency }}
                    <!-- <v-icon color="green" small>mdi-arrow-up-bold</v-icon> 40%  -->
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6  class="pa-1">
                <v-card hover>
                  <v-card-text> Discounts {{ salesData.discounts | currency }} </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6  class="pa-1">
                <v-card hover>
                  <v-card-text> Tax Collected {{ salesData.taxCollected | currency }} </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6  class="pa-1">
                <v-card hover>
                  <v-card-text> Net Sales {{ salesData.netSales | currency }} </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6  class="pa-1">
                <v-card hover>
                  <v-card-text> Estimated Costs {{ salesData.estimatedCost | currency }} </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6  class="pa-1">
                <v-card hover>
                  <v-card-text> Estimated Profit {{ salesData.netProfit | currency }} </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
          </v-layout>

          <!-- Revenue by location -->
          <div v-if="salesData && salesData.locations.length > 0">
            <v-flex class="my-2 text-xs-center">
              <h2>By Location</h2>
            </v-flex>
            <div  v-for="location in salesData.locations" :key="location.id">
              <v-flex class="my-2">
                <h2>{{ location.name }}</h2>
              </v-flex>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <PieChart :chartData="[
                  ['Label', 'Amount'],
                  ['Sales', (parseFloat(location.netSales) > 0) ? parseFloat(location.netSales) : 0],
                  ['Tax', (parseFloat(location.taxCollected) > 0) ? parseFloat(location.taxCollected) : 0],
                  ['Discounts', (parseFloat(location.discounts) > 0) ? parseFloat(location.discounts) : 0]]
                  ">
                    <template slot="header">
                      <v-layout column class="text-xs-center">
                        <h3>Revenue Breakdown</h3>
                        <h4>{{ location.revenue | currency }} </h4>
                      </v-layout>
                    </template>
                  </PieChart>
                </v-flex>
                <!-- <v-flex xs12 sm6>
                  <PieChart :chartData="[
                  ['Label', 'Amount'],
                  ['Cost', (parseFloat(location.estimatedCost) > 0) ? parseFloat(location.estimatedCost) : 0],
                  ['Profit', (parseFloat(location.netProfit) > 0) ? parseFloat(location.netProfit) : 0]]
                  ">
                    <template slot="header">
                      <v-layout column class="text-xs-center">
                        <h3>Profit and Loss</h3>
                        <h4>Total Sale: {{ location.netSales | currency }} </h4>
                      </v-layout>
                    </template>
                  </PieChart>
                </v-flex> -->
              </v-layout>
            </div>

          </div>

          <!-- Revenue by Employee -->
          <v-layout row ></v-layout>
        </v-layout>

      </v-container>
      </v-card>
    </div>
  </v-container>


</template>
<script>
import ReportViewBar from '@/components/ReportViewBar.vue';
import DateTimePicker from '@/components/DateTimePicker';
import reportService from '../service.js'
import locationService from '../../Location/service.js'
import employeeService from '../../Employee/service.js'
import PieChart from '../charts/PieChart'

export default {
  name: 'reports-sales',
  components: {
    PieChart,
    ReportViewBar,
    DateTimePicker,
  },
  data() {
    return {
      loading: false,
      start: this.$moment().startOf('day'),
      end: this.$moment().endOf('day'),
      dateTime: {
        start: this.$moment().startOf('day').toISOString(),
        end: this.$moment().endOf('day').toISOString(),
      },
      startDatePicker: {
        dialog: false,
        date: this.$moment().startOf('day').utc().format('YYYY-MM-DD'),
      },
      endDatePicker: {
        dialog: false,
        date: null,
      },
      locations: [],
      selectedLocations: [],
      employees: [],
      selectedEmployees: [],
      salesData: null,
    }
  },
  async created() {
    this.locations = (await locationService.getAll({ lite: true })).data
    this.loadEmployees()
    // this.employees = (await employeeService.getAll({ lite: true, noPagination: true, locations: this.selectedLocations })).data
    this.loadSales()
  },
  methods: {
    locationsSelected() {
      this.loadEmployees()
      this.loadSales()
    },
    async loadEmployees() {
      let locations = []
      this.selectedLocations.forEach(location => locations.push(location))
      this.employees = (await employeeService.getAll({ lite: true, noPagination: true, locations: locations })).data
    },
    openRevenue() {
      this.$router.push({ name: 'invoice-list', params: { date: this.dateTime } });
    },
    loadSales() {
      this.loading = true;
      return reportService.Sales.get({
        start: this.dateTime.start,
        end: this.dateTime.end,
        locations: this.selectedLocations,
        employees: this.selectedEmployees,
      })
      .then((response) => {
        this.loading = false;
        this.salesData = response.data
      })
      .catch(error => {
        this.loading = false;
        throw error
      });
    },
    generateLocationChartRevenueData(locationData) {
      if (this.locationData && this.locationData.revenue > 0) {
        const data = [['Label', 'Total']]
        data.push(['Sales', parseFloat(this.locationData.netSales)])
        data.push(['Discounts', parseFloat(this.locationData.discounts)])
        data.push(['Tax', parseFloat(this.locationData.taxCollected)])
        return data
      }
      return null
    },
  },
  computed: {
    revenueChartData() {
      if (this.salesData && this.salesData.revenue > 0) {
        // return [['Label', 'Total']].concat(Object.entries(this.salesData).map(([key, value]) => ([key, parseFloat(value)])))
        const data = [['Label', 'Total']]
        data.push(['Sales', parseFloat(this.salesData.netSales)])
        data.push(['Discounts', parseFloat(this.salesData.discounts)])
        data.push(['Tax', parseFloat(this.salesData.taxCollected)])
        return data
      }
      return null
    },
    salesChartData() {
      if (this.salesData && this.salesData.netSales > 0) {
        // return [['Label', 'Total']].concat(Object.entries(this.salesData).map(([key, value]) => ([key, parseFloat(value)])))
        const data = [['Label', 'Total']]
        data.push(['Cost', parseFloat(this.salesData.estimatedCost)])
        data.push(['Profit', parseFloat(this.salesData.netProfit)])
        return data
      }
      return null
    },
    startDateFormatted() {
      if (this.startDatePicker.date) {
        console.log(this.startDatePicker.date)
        return this.$moment(this.startDatePicker.date).format('MM/DD/YYYY')
      }
      return null
    },
    endDateFormatted: {
      get() {
        if (this.endDatePicker.date) {
          return this.$moment(this.endDatePicker.date).format('MM/DD/YYYY')
        }
        return null
      },
      set(val) {
        return this.endDatePicker.date = null
      },
    },
  },
}
</script>
